import { call, put, takeEvery } from "redux-saga/effects";
import { phongUuTienBuoiApi } from "../../../api/category/phongUuTienBuoiApi";
import { IPhongUuTienBuoi } from "../../../model/respone/category/IPhongUuTienBuoi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  ePhongUuTienBuoiActionIds,
  IPhongUuTienBuoiActionTypes,
} from "../../action-types/category/IPhongUuTienBuoiActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.phongUuTienBuoi;

export function* phongUuTienBuoiSaga(): any {
  yield takeEvery(ePhongUuTienBuoiActionIds.LOAD_START, loadWorker);
  yield takeEvery(ePhongUuTienBuoiActionIds.SAVE_START, saveWorker);
  yield takeEvery(ePhongUuTienBuoiActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(phongUuTienBuoiApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}
function* saveWorker(action: IPhongUuTienBuoiActionTypes): any {
  const payload = action.payload as IPhongUuTienBuoi;
  const res: IBaseRespone = payload.id > 0
    ? yield call(phongUuTienBuoiApi.Update, payload)
    : yield call(phongUuTienBuoiApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_SUCCESS(res.data));
  else yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
}
function* deleteWorker(action: IPhongUuTienBuoiActionTypes): any {
  const res: IBaseRespone = yield call(phongUuTienBuoiApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_SUCCESS(res.data));
  else yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
}
